<div class="col-md-12">
    <span class ="eventCalender">EVENTS CALENDAR</span>
    
    <div class="icons-div">
        <span class="icon-span calender-i-margin" routerLink='../events-calendar' routerLinkActive="active"><i class="fa fa-calendar icon-size" aria-hidden="true"></i></span>
        <span class="icon-span" routerLink='../events-list-view' routerLinkActive="active"><i class="fa fa-list-ul icon-size" aria-hidden="true"></i></span>
    </div>
</div>
